import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImagesService {
  public ProductIcons: ProductIcons = new ProductIcons();
}

export class ProductIcons {
  public ScrewPackage: string = 'assets/product-icons/screwpackage_vibrantBlue.svg';
  public BareScrew: string = 'assets/product-icons/screw_vibrantBlue.png';
  public PistonPackage: string = 'assets/product-icons/pistonpackage_vibrantBlue.png';
  public BluAstrumChillam: string = 'assets/product-icons/screwchiller_vibrantBlue.svg';
  public ScrewHeatPump: string = 'assets/product-icons/screwheatpump_vibrantBlue.svg';
  public CompaX: string = 'assets/product-icons/compaqX_vibrantBlue.svg';
  public portal: string = 'assets/product-icons/portal_45px_blue.svg';
  public footerBanner: string = 'assets/product-icons/FooterBanner.svg';
  public viewSwitch: string = 'assets/product-icons/ViewSwitch.svg';
  public share: string = 'assets/product-icons/16px_share.svg';
}
